<template>
    <div
        class="imageOverlay"
        :class="{'is-open': isOpen}"
        @click="isOpen = false"
    >
        <div
            class="imageOverlay__inner"
            @click.stop
        >
            <img
                v-if="src"
                class="imageOverlay__img"
                :src="src"
                alt=""
            />

            <button
                class="imageOverlay__closeBtn"
                @click.prevent="isOpen = false"
            >
                <span class="visually-hidden">Close</span>
            </button>
        </div>
    </div>
</template>


<script>
export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'ImageOverlay',

    data() {
        return {
            isOpen: false,
            src: null,
        }
    },




    /* Data Handling
    --------------------------------------------------------- */


    computed: {
    },


    watch: {
        isOpen(isOpen) {
            clearTimeout(this.srcTimer)

            if (isOpen) {
                this.$el.focus()
                document.addEventListener('keyup', this.onKeyUp)
            } else {
                document.removeEventListener('keyup', this.onKeyUp)

                this.srcTimer = setTimeout(() => {
                    this.$data.src = null
                }, 420)
            }
        },
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {

        /* Handlers
        --------------------------------------------------------- */

        onKeyUp(e) {
            if (e.key !== 'Escape') return

            e.preventDefault()
            e.stopPropagation()

            this.$data.isOpen = false
        },




        /* Actions
        --------------------------------------------------------- */

        open(src) {
            this.$data.src = src
            this.$data.isOpen = true
        },

    },

}

</script>
